<template>
    <a :href="`#comment-${comment.id}`" class="reply" v-if="comment">
        <avatar class="reply__avatar" :user="comment.author"></avatar>
        <span class="reply__text" v-html="comment.brief"></span>
        <attachment v-if="comment.attachment" :attachment="comment.attachment" :is-reply="true"></attachment>
    </a>
</template>

<script>
import Avatar from '../../Global/Avatar'
import Attachment from './Attachment'

export default {
    props: {
        comment: {
            type: Object,
            required: true
        }
    },

    components: {
        Avatar,
        Attachment
    }
}
</script>